import * as yup from 'yup';

export const giftingTopUpWalletFormSchema = yup.object().shape({
  pointsAmount: yup
    .number()
    .required('The points amount is mandatory.')
    .min(1000, 'Minimum points amount is 1,000 (£5).')
    .max(20000000, 'Maximum points amount is 20,000,000 (£100,000).')
    .test(
      'multiple-of-1000',
      'The point amount must be in increments of 1,000.',
      (value) => value !== undefined && value % 1000 === 0
    ),
});

export default giftingTopUpWalletFormSchema;
